import React from 'react'
import Home from '../../components/home/Home';
import Layout from '../../components/layout/Layout';

const HomeContent = () => {
    return ( <Layout children={ < Home /> } /> )
}

export default HomeContent